// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { EncounterScribeSessionFieldValueResponse } from './encounter-scribe-session-field-value-response';

/** See com.rev360.pms.api.controller.encounter.scribe.EncounterScribeSessionResponse */
/* istanbul ignore next */
@GandalfModel
export class EncounterScribeSessionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfProperty({ designType: Number })
	encounterScribeSessionId!: number;

	@GandalfProperty({ designType: String })
	externalIdentifier!: string;

	@GandalfConstantDecorator(constants.EncounterScribeSessionExternalSource)
	@GandalfProperty({ designType: constants.EncounterScribeSessionExternalSource })
	externalSource!: constants.EncounterScribeSessionExternalSource;

	@GandalfArray(EncounterScribeSessionFieldValueResponse)
	fieldValues!: EncounterScribeSessionFieldValueResponse[];

}
